(function () {

seedWebApp.controller('StageEmailModalCtrl', StageEmailModalCtrl);
    function StageEmailModalCtrl($uibModalInstance, item, translation, UtilsService, ToastService) {
        var ctrl = this;

        ctrl.item = item;
        ctrl.translation = translation;

        console.log('StageEmailModal', ctrl.item);

        //CAMPOS DE BRATS
        ctrl.availableFields = function () {
            var fields = [];

            fields.push({ name: '##IssueID', description: 'BRATS Number' });
            fields.push({ name: '##BratID', description: 'Brat ID' });
            fields.push({ name: '##OrderID', description: 'Order ID' });
            
            fields.push({ name: '##ContactID', description: 'Customer ID' });
            fields.push({ name: '##ContactName', description: 'Customer Name' });

            //fields.push({ name: '##StatusID', description: 'Status' });
            fields.push({ name: '##ProcExpID', description: 'Invoice Number' });
            fields.push({ name: '##ContractNumber', description: 'PO# Number' });
            fields.push({ name: '##IssueSubject', description: 'Assunto' });
            fields.push({ name: '##IssueDescription', description: 'Descrição' });

            //fields.push({ name: '##AcceptComments', description: 'Accept Comments' });
            //fields.push({ name: '##RejectComments', description: 'Reject Comments' });
            //fields.push({ name: '##VesselName', description: 'Vessel Name' });

            //fields.push({ name: '##BookingID', description: '#Booking' });
            //fields.push({ name: '##InvoiceDate', description: 'Data Faturamento' });

            //fields.push({ name: '##UserID', description: 'User id that triggered event' });

            //fields.push({ name: '##ProcExpLink', description: 'Link to order' });
            //fields.push({ name: '##ShippingDocsLink', description: 'Link to shipping documents' });

            //fields.push({ name: '##ShippingDate', description: 'Ship Date' });
            //fields.push({ name: '##DeparturePointID', description: 'Pto Saida Embarque' });

            return fields;
        }
        ctrl.fields = ctrl.availableFields();

        ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        ctrl.copyField = function (field) {
            UtilsService.copyToClipboard(field.name);
            successToast(field.name + ' copiado para o clipboard');
        };

        ctrl.getMarkdownHelp = function () {
            var msg = 'Aceita Markdown básico:';            
            msg += '\n# Header1';
            msg += '\n## Header2';
            msg += '\n### Header3';
            msg += '\n**bold**';
            msg += '\n_italic_';            
            msg += '\n- bullet list';            
            //msg += '\n- bullet list';       

            return msg;
        };

        function successToast(msg) {
            ToastService.clear();
            ToastService.createToast(ctrl.translation.Success, msg, 8000, 'success');
        }
    }
})();